import angular from 'angular';
import 'angular-bootstrap';
import 'leaflet';
import 'leaflet-draw';
import locales from '../../locale';
import './gamesServices';
import 'Leaflet.Snap';
import '../../../scripts/leaflet-label-shim';

'use strict';

const gamesControllers = angular.module('applicationModule.gamesControllers', [
    'applicationModule.gamesServices',
    'commonModule.localizationMapService',
    'ui.bootstrap'
]);

// Games List Controller
gamesControllers.controller('GamesListController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', 'Game', 'growl', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $stateParams, NgTableParams, Game, growl, AppsoupAPI, Permissions) {
    'use strict';

    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('games');
    $scope.application_id = $stateParams.application_id;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Game.getList($scope.application_id, params._params)
                .then(function (response) {
                    params.total(response.games.total);
                    params.count(response.games.per_page);
                    params.page(response.games.current_page);
                    return response.games.data;
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.removeGame = function (id, index) {
        Game.remove(id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.GAMES.SUCCESS.DELETE_GAME');
                    $scope.tableParams.data.splice(index, 1);
                } else {
                    growl.error('MODULES.GAMES.ERROR.DELETE');
                }
            });
    };

}]);

// Game Page Controller
gamesControllers.controller('GamePageController', ['$scope', '$rootScope', '$stateParams', '$state', 'Game', 'growl', 'Permissions', function ($scope, $rootScope, $stateParams, $state, Game, growl, Permissions) {
    'use strict';

    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('games');
    $scope.application_id = $stateParams.application_id;

    $scope.editMode = false;
    $scope.game = {};

    $scope.game.app_id = $stateParams.application_id;

    if (angular.isDefined($stateParams.gameId)) {
        $scope.editMode = true;
        $rootScope.doingResolve = true;

        var gameId = $stateParams.gameId;

        Game.get(gameId, $stateParams.application_id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    $scope.game = data.game;
                } else {
                    growl.error('MODULES.GAMES.' + data.error);
                }
            })
            .catch(function () {
                $state.go('appsoup.application.games', {application_id: $stateParams.application_id}, growl.error('ERROR.EMPTY_DATA'));
            })
            .finally(function () {
                $rootScope.doingResolve = false;
            });
    }

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.game.application_id = $stateParams.application_id;
        $scope.isLoading = true;
        Game.save($scope.game, $scope.editMode)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.GAMES.SUCCESS.' + ($scope.editMode ? 'GAME_EDITED' : 'GAME_CREATED'));
                    $state.go('appsoup.application.games', {application_id: $stateParams.application_id});
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.success('MODULES.GAMES.ERROR.' + ($scope.editMode ? 'GAME_EDITED' : 'GAME_CREATED'));
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.games', {application_id: $stateParams.application_id});
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'MODULES.GAMES.ERROR.REQUIRE.NAME'}]
    };

}]);

// Games Points Controller
gamesControllers.controller('GamesPointsController', ['$scope', '$rootScope', '$stateParams', '$modal', 'NgTableParams', 'GamePoint', 'AppsoupAPI', 'Permissions', 'LocalizationMapService', function ($scope, $rootScope, $stateParams, $modal, NgTableParams, GamePoint, AppsoupAPI, Permissions, LocalizationMapService) {
    'use strict';

    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('games');
    $scope.application_id = $stateParams.application_id;
    $scope.gameId = $stateParams.gameId;
    $scope.drawEnabled = true;

    $scope.map = LocalizationMapService.initMap();

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return GamePoint.getList($scope.gameId, $scope.application_id, params._params)
                .then(function (response) {
                    $scope.types = response.types;
                    $scope.points = response.points;
                    params.total(response.points.total);
                    params.count(response.points.per_page);
                    params.page(response.points.current_page);
                    return response.points.data;
                })
                .finally(function () {
                    $scope.isLoading = false;
                    LocalizationMapService.clearMap();
                    $scope.points = LocalizationMapService.displayLocalizations($scope.points.data, $scope.writeAccess);
                    $scope.map = LocalizationMapService.getMap();
                    $scope.map.fireEvent('resize');
                });
        },
        counts: []
    });

    /**
     * Odpala rysowanie lokalizacji
     */
    $scope.drawLocalization = function () {
        if (!$scope.writeAccess)
            return;
        $scope.drawEnabled = false;
        LocalizationMapService.enableLocalizationSelector();
    };

    /**
     * Przerywa rysowanie lokalizacji
     */
    $scope.cancel = function () {
        $scope.drawEnabled = true;
        LocalizationMapService.cancelElement();
    };

    $scope.selectPoint = function (point) {
        var zoom = checkZoomByRadius(point);
        $scope.point = angular.copy(point);
        $scope.point.lat = parseFloat($scope.point.lat);
        $scope.point.lng = parseFloat($scope.point.lng);
        $('#map')[0].scrollIntoView(true);
        LocalizationMapService.changeView($scope.point.lat, $scope.point.lng, zoom);
        GamePoint.getPoint(point.id, $scope.application_id)
            .then(function () {
                if (angular.isNullOrUndefined($rootScope.open)) {
                    $rootScope.open = true;
                    if (angular.isDefined(point.radius)) {
                        point.radius = Math.round(point.radius);
                    }
                    initModal('edit', point);
                }
            });
    };

    /**
     * Event po narysowaniu nowej lokalizacji
     */
    $scope.$on('elementDrawn', function (event, data) {
        var layer = data.layer;
        var point = [layer._latlng.lat, layer._latlng.lng];
        var radius = layer._mRadius;
        LocalizationMapService.disableLocalizationSelector();
        $scope.drawEnabled = true;
        if (angular.isDefinedNotEmpty(point)) {
            var point_loc = {
                lat: point[0],
                lng: point[1]
            };
            initModal('create', {
                lat: point_loc.lat,
                lng: point_loc.lng,
                radius: Math.round(radius),
                app_id: $scope.application_id,
                game_id: $scope.gameId
            }, layer);
        }
    });

    /**
     * Event po kliku na lokalizację
     */
    $scope.$on('elementEdit', function (e, point) {
        if ($scope.drawEnabled) {
            GamePoint.getPoint(point.id, $scope.application_id)
                .then(function () {
                    if (angular.isNullOrUndefined($rootScope.open)) {
                        $rootScope.open = true;
                        if (angular.isDefined(point.radius)) {
                            point.radius = Math.round(point.radius);
                        }
                        initModal('edit', point);
                    }
                });
        }
    });
    /**
     * Event po usunięciu lokalizacji
     */
    $rootScope.$on('elementRemoved', function (e, point) {
        angular.forEach($scope.points, function (p, index) {
            if (point['id'] === p.id)
                $scope.points.splice(index, 1);
        });
    });
    /**
     * Event po zapisaniu lokalizacji
     */
    $rootScope.$on('elementSaved', function (e, point, editMode) {
        var points = [];
        if (editMode) {
            angular.forEach($scope.points, function (p, index) {
                if (point['id'] === p.id)
                    $scope.points[index] = point;
            });
        } else {
            points = $scope.points;
            points.push(point);
            $scope.points = points;
        }
    });

    /**
     * Inituje modal obszaru
     *
     * @param mode create|edit
     * @param point
     * @param layer warstwa na której ma utworzyć nowy obszar - wymagane tylko przy tworzeniu
     */
    function initModal(mode, point, layer) {
        if (!$scope.writeAccess)
            return;
        if (angular.isUndefined(mode))
            mode = 'create';
        var data = {
            editMode: (mode !== 'create'),
            point: point
        };
        if (mode === 'create')
            data.layer = layer;
        var ModalInstance = $modal.open({
            templateUrl: 'views/application/games/components/modal/point.tpl.html',
            controller: 'PointModalController',
            resolve: {
                modalData: function () {
                    return data;
                }
            }
        });
        ModalInstance.result.then(function (data) {
            $rootScope.open = null;
            if (data) {
                angular.forEach($scope.points, function (val, key) {
                    if (data.point.id === val.id) {
                        if (key === 'relationships' && data.point.relationships == null) {
                            data.point.relationships = [];
                        }
                        $scope.points[key] = data.point;
                    }
                }, $scope.points);
                LocalizationMapService.clearMap();
                LocalizationMapService.displayLocalizations($scope.points, true);
                $scope.$broadcast('show-errors-reset');
                if (mode === 'create' || point.radius !== data.point.radius) {
                    // layer = LocalizationMapService.displayLocalization(data.point);
                }
                $scope.drawEnabled = true;
            }
        }).catch(() => {});
    }

    /**
     * Zwraca zoom w zależności od zdefiniowania pola radius
     * @param {type} point
     * @returns zoom
     */
    function checkZoomByRadius(point) {
        var zoom;
        if (angular.isDefined(point.radius)) {
            zoom = LocalizationMapService.zoomByRadius(point.radius);
        } else {
            zoom = LocalizationMapService.maxZoom;
        }

        return zoom;
    }
}]);

// Point Modal Controller
gamesControllers.controller('PointModalController', ['$scope', '$modalInstance', 'modalData', 'growl', 'LocalizationMapService', '$rootScope', 'GamePoint', function ($scope, $modalInstance, modalData, growl, LocalizationMapService, $rootScope, GamePoint) {
    'use strict';

    $scope.editMode = modalData.editMode;

    $scope.point = {};
    $scope.point = angular.copy(modalData.point);

    if (angular.isDefined($scope.point.radius)) {
        $scope.point.radius = parseFloat($scope.point.radius);
    }
    if (angular.isDefined($scope.point.lat)) {
        $scope.point.lat = parseFloat(Number($scope.point.lat).toFixed(6));
    }
    if (angular.isDefined($scope.point.lng)) {
        $scope.point.lng = parseFloat(Number($scope.point.lng).toFixed(6));
    }

    if (angular.isNullOrUndefined($scope.point.relationships)) {
        $scope.point.relationships = [];
    }

    $scope.types = [];
    $scope.clues = [];

    GamePoint.getTypes()
        .then(function (res) {
            var response = res.data;
            if (response.success) {
                $scope.types = response.types;
            }
        });

    var pointId;

    if (angular.isDefined($scope.point.id)) {
        pointId = $scope.point.id;
    }
    GamePoint.getCluePoints($scope.point.game_id, pointId)
        .then(function (res) {
            var response = res.data;
            $scope.errorType = false;

            if (response.success) {
                $scope.clues = response.clues;
                if (angular.isDefined($scope.point.relationships) && Object.keys($scope.point.relationships).length > 0) {
                    var relationships = [];
                    angular.forEach($scope.point.relationships, function (val) {
                        angular.forEach($scope.clues, function (v, k) {
                            if (val.id === v.id) {
                                relationships.push($scope.clues[k]);
                            }
                        });
                    });
                    $scope.point.relationships = relationships;
                }
            }
        });


    $scope.savePoint = function (point) {
        $scope.$broadcast('show-errors-check-validity');
        if ($scope.pointForm.$valid) {
            $scope.isLoading = true;

            GamePoint.save(point, $scope.editMode)
                .then(function (result) {
                    let data = result.data;

                    $scope.errorType = false;
                    if (data.success) {
                        growl.success('MODULES.GAMES.SUCCESS.POINT.' + ($scope.editMode ? 'EDIT' : 'NEW'));
                        $rootScope.$broadcast('elementSaved', data.point, $scope.editMode);
                        $modalInstance.close(data);
                        $scope.$broadcast('show-errors-reset');
                    } else if (data.error) {
                        if (angular.isDefined(data.error.type)) {
                            $scope.errorType = true;
                            data.error.type[0] = 'MODULES.GAMES.ERROR.REQUIRE.TYPE';
                        }
                        if (typeof data.error === 'object') {
                            $scope.formErrors = data.error;
                        } else {
                            growl.error(data.error);
                        }
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        }
    };

    $scope.deletePoint = function () {
        if (angular.isDefined($scope.point.id)) {
            $scope.isLoading = true;
            GamePoint.remove($scope.point)
                .then(function (result) {
                    let data = result.data;

                    if (data.success) {
                        growl.success('MODULES.GAMES.SUCCESS.POINT.DELETE');
                        // Remove point from map
                        if (angular.isDefined($scope.point._leaflet_id)) {
                            LocalizationMapService.removeElement($scope.point._leaflet_id);
                        } else {
                            throw new Error('Could not delete area from map, no _leaflet_id property!');
                        }
                        $rootScope.$broadcast('elementRemoved', $scope.point);
                        $modalInstance.dismiss($scope.point);
                    } else if (data.error) {
                        growl.error(data.error);
                        $scope.formErrors = data.error;
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        }
    };

    $scope.cancel = function () {
        $rootScope.drawEnabled = true;
        $rootScope.open = null;
        $modalInstance.dismiss('cancel');
    };

    $scope.$on('modal.closing', function () {
        $rootScope.open = null;
    });

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'MODULES.GAMES.ERROR.REQUIRE.POINT'}],
        'type': [{type: '$invalid', msg: 'MODULES.GAMES.ERROR.REQUIRE.TYPE'}],
        'target': [{type: '$invalid', msg: 'MODULES.GAMES.ERROR.REQUIRE.TARGET'}],
        'place': [{type: '$invalid', msg: 'MODULES.GAMES.ERROR.REQUIRE.PLACE'}],
        'story': [{type: '$invalid', msg: 'MODULES.GAMES.ERROR.REQUIRE.STORY'}],
        'survey_clue': [{type: '$invalid', msg: 'MODULES.GAMES.ERROR.REQUIRE.SURVEY_CLUE'}],
        'password': [{type: '$invalid', msg: 'MODULES.GAMES.ERROR.REQUIRE.PASSWORD'}],
        'relationships': [{type: '$invalid', msg: 'MODULES.GAMES.ERROR.REQUIRE.RELATIONSHIPS'}],
        'radius': [{error: 'required', msg: 'MODULES.GAMES.ERROR.REQUIRE.RADIUS'}, {
            error: 'pattern',
            msg: 'MODULES.GAMES.ERROR.MIN.RADIUS'
        }],
        'lat': [
            {error: 'required', msg: 'MODULES.GAMES.ERROR.REQUIRE.LAT'},
            {error: 'pattern', msg: 'MODULES.GAMES.ERROR.PATTERN.LAT'},
            {error: 'min', msg: 'MODULES.GAMES.ERROR.MIN.LAT'},
            {error: 'max', msg: 'MODULES.GAMES.ERROR.MAX.LAT'}
        ],
        'lng': [
            {error: 'required', msg: 'MODULES.GAMES.ERROR.REQUIRE.LNG'},
            {error: 'pattern', msg: 'MODULES.GAMES.ERROR.PATTERN.LNG'},
            {error: 'min', msg: 'MODULES.GAMES.ERROR.MIN.LNG'},
            {error: 'max', msg: 'MODULES.GAMES.ERROR.MAX.LNG'}
        ]
    };
}]);

export default gamesControllers;
